import React, { Component } from 'react';
import { Input, Icon } from 'antd';

import { inject, observer } from 'mobx-react';

import { MagnifierIcon } from '../../../../../common/icons';

import './FullTextSearch.css';

@inject('filterStore', 'fleetCustomerContractsStore')
@observer
export default class FullTextSearch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fullTextSearch: null,
    };
  }

  componentWillUnmount = () => {
    this.emitEmpty();
  };

  componentDidMount() {
    if (this.props.filterStore.fullTextSearch) {
      this.init(this.props.filterStore.fullTextSearch);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.status !== this.props.status && this.props.status === false) {
      this.emitEmpty();
    }
  }

  search = () => {
    const { filterStore, fleetCustomerContractsStore } = this.props;
    filterStore.add(`textVehicleManager`, fleetCustomerContractsStore.textSearchFns(filterStore.fullTextSearch));
    filterStore.apply();
  };

  keyPress = e => {
    if (e.keyCode === 13) {
      this.search();
    }
  };

  emitEmpty = () => {
    const { filterStore } = this.props;
    filterStore.fullTextSearch = null;
    filterStore.remove(`textVehicleManager`);
    filterStore.apply();
  };

  onChange = e => {
    const { filterStore } = this.props;
    filterStore.fullTextSearch = e.target.value;
  };

  render() {
    const suffix = this.props.filterStore.fullTextSearch ? <Icon type="close-circle" onClick={this.emitEmpty} style={{ color: 'white' }} /> : null;
    return (
      <div className="FullTextSearch">
        <Input
          placeholder={this.props.placeholder}
          prefix={<MagnifierIcon onClick={this.search} />}
          value={this.props.filterStore.fullTextSearch}
          onChange={this.onChange}
          onKeyDown={this.keyPress}
          suffix={suffix}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/VehiclesManagerDashboard/SubHeader/FullTextSearch/FullTextSearch.js